import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { DonorCrmService } from 'src/app/shared/services/donor-crm/donor-crm.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';
import { CommonSharedServiceService } from 'src/app/shared/shared-services/common-shared-service/common-shared-service.service';

@Component({
  selector: 'app-donor-management',
  templateUrl: './donor-management.component.html',
  styleUrl: './donor-management.component.scss',
})
export class DonorManagementComponent {
  @ViewChild('donorList', { static: false }) dataGrid!: DxDataGridComponent;
  public isNgoAdmin: boolean = this.localStorageService.getIsNgoAdmin();
  public lapsedDonorPopup: boolean = false;

  public overviewCarts = [
    {
      carts_icon: './assets/images/icon/donation_total.svg',
      carts_name: 'Total Donors',
      id: 'total_donor',
      isAmount: false,
      calculated_data: 0,
    },
    {
      carts_icon: './assets/images/icon/hand_dollar.svg',
      carts_name: 'Total Donations',
      id: 'total_donation',
      isAmount: true,
      calculated_data: 0,
    },
    {
      carts_icon: './assets/images/icon/active_donors.svg',
      carts_name: 'Avg. Donation Frequency',
      id: 'avg_donation_freq',
      isAmount: false,
      calculated_data: 0,
    },
    {
      carts_icon: './assets/images/icon/education_fund.svg',
      carts_name: 'Top Campaign',
      id: 'top_campaign_title',
      isAmount: false,
      calculated_data: 'None',
    },
  ];

  public today: Date = new Date();
  public oneYearAgo: Date = new Date(
    this.today.getFullYear(),
    this.today.getMonth() - 1,
    this.today.getDate(),
    this.today.getHours(),
    this.today.getMinutes(),
    this.today.getSeconds(),
    this.today.getMilliseconds()
  );
  public startDate: Date = this.oneYearAgo;
  public endDate: Date = this.today;

  public donorsList: any = [];
  public sessionUser = this.localStorageService.getSessionUser();

  constructor(
    private readonly router: Router,
    private readonly donorCrmService: DonorCrmService,
    private readonly utilitiesService: UtilitiesService,
    private readonly localStorageService: LocalStorageService,
    private readonly sharedService: CommonSharedServiceService
  ) {}

  ngOnInit() {
    // if (this.isNgoAdmin) {
    //   this.overviewCarts.splice(2, 2);
    // }

    this.getAllDonationList();
    this.getAllDonorCrmManagement();

    this.sharedService.ngoSelectionAction$.subscribe((action) => {
      this.getAllDonationList();
      this.getAllDonorCrmManagement();
    });
    this.sharedService.updateReceiptPopupState(false);
  }

  public getAllDonationList(): void {
    this.donorCrmService.getDonorCrmManagementDashboard().subscribe({
      next: (result: any) => {
        this.overviewCarts.forEach((item: any) => {
          item.calculated_data = result[item?.id] || 0;
        });
      },
    });
  }

  public getAllDonorCrmManagement(): void {
    this.donorCrmService
      .getAllDonorCrmManagement(String(this.startDate), String(this.endDate))
      .subscribe({
        next: (result: any) => {
          this.donorsList = result;
        },
      });
  }

  public closeCreateEmailPopup() {
    this.lapsedDonorPopup = false;
  }

  public lapsedPopup() {
    this.lapsedDonorPopup = true;
  }

  public showReceiptPopup(receipt: any): void {
    this.sharedService.updateReceiptPopupState(true);
  }

  public updateDateRange(event: any) {
    if (event && event.value) {
      this.startDate = event.value[0]; // First value is startDate
      this.endDate = event.value[1]; // Second value is endDate
      this.getAllDonorCrmManagement();
    }
  }

  public exportGrid(): void {
    if (this.dataGrid && this.donorsList?.length > 0) {
      const event = {
        component: this.dataGrid.instance,
        cancel: false,
        fileName: 'DonorList.xlsx',
        selectedRowsOnly: false,
        format: 'xlsx',
      };
      this.utilitiesService.onExportingDataGrid(event, 'DonorList');
    } else if (this.donorsList?.length === 0) {
      this.utilitiesService.showSwal('error', 'No data available');
    }
  }

  public navigateToProfile(data: any) {
    console.log('managwment', data);
    const encryptedParams = this.localStorageService.encryptObjectUrl({
      donorId: data.donor_id,
    });
    if (
      this.localStorageService.getSelectedRole()?.short_form === 'system_admin'
    ) {
      this.router.navigate(['/admin/donor-crm/donor-info'], {
        queryParams: { data: encryptedParams },
      });
    } else {
      this.router.navigate(['/dashboard/donor-crm/donor-info'], {
        queryParams: { data: encryptedParams },
      });
    }
  }

  public getUrl(url: string): string {
    return this.utilitiesService.jsonParse(url)?.url;
  }
}
